import React from "react";
import { motion } from "framer-motion";
import { StaggerGrid, StaggerItem, MotionDiv } from "../../utils/animations";
import "./home.css";

const TEAM = [
    {
        name: "Edwin Fajardo Murillo",
        role: "Pentester · Red Team · Full Stack · Bug Bounty Hunter",
        bio: "Especialista en seguridad ofensiva, ingeniería inversa y desarrollo full stack. Diseña arquitecturas seguras y ejecuta pruebas de penetración para proteger sistemas críticos.",
        initials: "EF",
        accent: "team-card--cyan",
        skills: ["Pentesting", "Red Team", "Ingeniería Inversa", "Full Stack", "Hardening"],
        linkedin: "https://www.linkedin.com/in/edwinfarleyfajardo/",
    },
    {
        name: "Raúl Andrés Fajardo Murillo",
        role: "Fundador y CEO de EMMPIEZA · Máster en IA · Seguridad operacional",
        bio: "Consultor en transformación digital y seguridad operacional en aviación. Militar retirado de la Fuerza Aeroespacial Colombiana con 20 años de experiencia, ingeniero mecatrónico y máster en IA. Desarrolla soluciones predictivas, analítica de datos, software multiplataforma y formación técnica para sectores complejos.",
        book: {
            title: "«El retorno de los polímatas»",
            url: "https://www.amazon.com/dp/B0H618GF8F",
        },
        initials: "RF",
        accent: "team-card--violet",
        skills: ["IA & RAG", "Python & ETL", "Análisis de Datos", "Seguridad Operacional", "Mecatrónica"],
        linkedin: "https://www.linkedin.com/in/raulandresfajardo/",
    },
];

function openLinkedIn(url) {
    window.open(url, "_blank", "noopener,noreferrer");
}

function TeamSection() {
    return (
        <section id="equipo" className="team-section">
            <div className="section-container">
                <MotionDiv className="section-header">
                    <div className="section-tag">Nuestro Equipo</div>
                    <h2 className="section-title">
                        Expertos en tecnología y seguridad
                    </h2>
                    <p className="section-subtitle">
                        Combinamos ciberseguridad ofensiva, desarrollo de software e inteligencia artificial
                        para entregar soluciones integrales de alto impacto.
                    </p>
                </MotionDiv>

                <StaggerGrid className="team-grid">
                    {TEAM.map((member) => (
                        <StaggerItem key={member.name}>
                            <motion.article
                                className={`team-card team-card--clickable ${member.accent}`}
                                whileHover={{ y: -6, scale: 1.01 }}
                                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                role="link"
                                tabIndex={0}
                                aria-label={`Ver perfil de LinkedIn de ${member.name}`}
                                onClick={() => openLinkedIn(member.linkedin)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        openLinkedIn(member.linkedin);
                                    }
                                }}
                            >
                                <div className="team-card-glow" aria-hidden="true" />
                                <div className="team-avatar">{member.initials}</div>
                                <h3 className="team-name">{member.name}</h3>
                                <p className="team-role">{member.role}</p>
                                <p className="team-bio">
                                    {member.bio}
                                    {member.book ? (
                                        <>
                                            {" "}
                                            <a
                                                href={member.book.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="team-book-link"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {member.book.title}
                                            </a>
                                            .
                                        </>
                                    ) : null}
                                </p>
                                <div className="team-skills">
                                    {member.skills.map((skill) => (
                                        <span key={skill} className="team-skill-badge">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </motion.article>
                        </StaggerItem>
                    ))}
                </StaggerGrid>
            </div>
        </section>
    );
}

export default TeamSection;
